import { Role } from '@agilox/common';
import { MenuPoint, MenuPointCallbackAction } from '@agilox/ui-common';
import { MenuPointUrl } from '../../enums/menupoint-url.enum';

export const lifecycleMenuPoints = {
	dashboard: {
		name: 'menu.dashboard',
		url: MenuPointUrl.DASHBOARD,
		icon: 'dashboard',
		roles: [Role.superuser, Role.support, Role.service],
	} as MenuPoint,
	replay: {
		name: 'menu.replay',
		url: MenuPointUrl.REPLAY,
		icon: 'load_backward',
		roles: [],
	} as MenuPoint,
	remote: {
		name: 'menu.remote',
		url: MenuPointUrl.REMOTE,
		icon: 'controller',
		roles: [],
	} as MenuPoint,
	help: {
		name: 'menu.help',
		url: '',
		icon: 'o_quesmark',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.HELP,
	} as MenuPoint,
	logout: {
		name: 'general.logout',
		url: '',
		icon: 'logout',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.LOGOUT,
	} as MenuPoint,
};
